import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import useNavTabBar from './hooks/useNavTabBar';

import ChevronRight from '../svg/ChevronRight';

function ActionNext(props) {
  const { active, onClick } = useNavTabBar('next');

  return (
    <div id={`ref-next`} onClick={ active ? onClick : null } className={`arrow-link chevron-right ${active && `active`}`} style={{ cursor: active ? `pointer` : `default` }}>
      <ChevronRight color={ active ? Config.TYPE_LIGHT : Config.TYPE_PLACEHOLDER } />
    </div>
  )
}

ActionNext.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func
}

export default ActionNext;
